module.exports = __webpack_public_path__ + "static/media/carbon_accounting.290ac638.webp";